import { Dropdown, Menu, Button, Select, DatePicker } from "antd";
import moment from "moment";

import { CalendarOutlined, DownOutlined } from "@ant-design/icons";
import { General } from "../../../util/General";
import styles from "./index.module.less";
import { MultiFunctionDateFilterProps, useMultiFunctionDateFilter } from "./index.hook";

const { Option } = Select;
const { RangePicker } = DatePicker;

const MultiFunctionDateFilter = (props: MultiFunctionDateFilterProps) => {
  const config = useMultiFunctionDateFilter(props);

  const menu = (
    <Menu onClick={({ key }) => config.handleDropdownClick(key)}>
      <Menu.Item key="lastNDays">Last N Days</Menu.Item>
      <Menu.Item key="customDateFilter">Custom Date Filter</Menu.Item>
      <Menu.Item key="allMonths">All Months</Menu.Item>
    </Menu>
  );

  return (
    <div className={styles["container"]}>
      {/* Render Last N Days Buttons in a single line */}
      {config.showLastNDays && (
        <div className={styles["filter-LastNDays"]}>
          {[1, 7, 15, 30].map((days) => {
            const isSelected = config.selectedDays === days;
            return (
              <div key={days} className={`${styles["filter-option"]} ${isSelected ? styles["filter-option-selected"] : styles["filter-option-not-selected"]}`} onClick={() => config.handleLastNDaysClick(days)}>
                {days}
              </div>
            );
          })}
        </div>
      )}

      {/* Render Custom Date Picker */}
      {config.showCustomDatePicker && (
        <RangePicker //
          getPopupContainer={(trigger) => document.body}
          disabledDate={General.disabledDate}
          disabledTime={General.disabledRangeTime}
          className={styles.datePicker}
          showTime={{ format: "HH:mm" }}
          format="DD-MM-YYYY HH:mm"
          onChange={config.handleCustomDateSelection}
        />
      )}

      {/* Render All Months Select with Search */}
      {config.showAllMonths && (
        <Select className={styles["monthSelect"]} showSearch placeholder="Select a Month" onChange={(value) => config.handleMonthSelection(moment(value))} filterOption={General.searchFilterOnSelect}>
          {config.getMonthsList().map((month) => (
            <Option key={month.value} value={month.value} label={month.label}>
              {month.label}
            </Option>
          ))}
        </Select>
      )}

      <Dropdown overlay={menu} trigger={["click"]} className={styles["dropdown-filter-options"]}>
        <Button type="primary">
          <CalendarOutlined />
          {config.selectedOption || "Select Date Filter"}
          <DownOutlined style={{ marginLeft: 8 }} />
        </Button>
      </Dropdown>
    </div>
  );
};

export default MultiFunctionDateFilter;
